export default "__VITE_ASSET__DfnvK$vE__"